import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  quote: string;
}
export function TestimonialCard({
  name,
  age,
  quote
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-lg shadow-sm border border-[#E5E0D8] relative" data-id="element-8">
      <Quote className="absolute top-4 left-4 w-8 h-8 text-[#D4915D] opacity-20" data-id="element-9" />
      <p className="text-gray-700 font-serif italic mb-4 relative z-10 pt-4" data-id="element-10">
        "{quote}"
      </p>
      <div className="flex items-center gap-2 mt-auto" data-id="element-11">
        <div className="w-8 h-8 rounded-full bg-[#F5F1E8] flex items-center justify-center text-[#D4915D] font-bold font-serif text-sm" data-id="element-12">
          {name.charAt(0)}
        </div>
        <div data-id="element-13">
          <p className="text-sm font-bold text-gray-900" data-id="element-14">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-15">{age} años</p>
        </div>
      </div>
    </div>;
}